import { render, staticRenderFns } from "./commodityPriceChange.vue?vue&type=template&id=2aff50e5&scoped=true&"
import script from "./commodityPriceChange.vue?vue&type=script&lang=js&"
export * from "./commodityPriceChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff50e5",
  null
  
)

export default component.exports